export default {
    newsFiveTitle: 'Cooking Data, Building "Credit Scoring"',
    newsFiveTime: "pubdate",
    newsFiveRead:"Pageviews",
    newsFiveSource:"Article source:",
    newsFiveDetail: [
        {
            p: 'How a financial technology startup builds a customer "credit scoring" database'
        },
        {
            p: "Marsya Nabila - 4 December 2019"
        },
        {
            p: "Have a bank account, but when you apply for a credit card it's always rejected? Here you enter the underbanked group. Under underbanked, there is unbanked which means you don't have a bank account."
        },
        {
            p: 'The two groups above have been "isolated" by banks and other conventional financial services, even though they have great business potential. The utilization of this segment is low and the 111 banks operating in Indonesia cannot take advantage of it because it is too risky.'
        },
        {
            p: "According to the latest e-Conomy SEA 2019 report compiled by Google, Temasek, and Bain & Company, there are 51% of Indonesians who fall into the unbanked category; underbanked 26%; and banked 23%."
        },
        {
            h4: "In general, in Southeast Asia, 75% of the population in Southeast Asia is categorized as underbanked and unbanked. They are under-served for various reasons."
        },
        {
            image:require('@/assets/idImage/newdetail/newfive1.jpg')
        },
        {
            p: "From the financial institution's point of view, there is a high cost to serve them that is not worth the potential low income in the medium term. Other reasons include a limited credit history, low savings rates, and 'limited awareness' when it comes to insurance or investments."
        },
        {
            p: "The common thread here is inclusion. How to increase the literacy of people who choose not to join the formal banking system to enter the ecosystem."
        },
        {
            p: "The classic reason for banks not to work on these two customer segments is the unavailability of data in BI Checking (now SLIK). With a banking system that is designed to be so exclusive, this forces banks to play it safe. If the financial reports are a little bad, they are immediately reprimanded by the regulator."
        },
        {
            p: "Banks in Indonesia have a high cost of funds. This resulted in high interest charged to customers. The country's net interest margin (NIM) is the highest in Southeast Asia, at 4.69% in August 2019 according to the OJK. Compare this with Singapore's NIM which is 'only' at the level of 3.62%."
        },
        {
            p: "The business potential that was left unattended for so long was finally exploited by fintech players, both lending and payment, which started to make banks break out in a cold sweat."
        },
        {
            image:require('@/assets/idImage/newdetail/newfive2.jpg')
        },
        {
            p: 'See how Akulaku and Kredivo are developing, two of the biggest fintech players on the lending side that offer "digital credit card" convenience. The process is completely done online and in a matter of minutes customers can immediately get approval.'
        },
        {
            p: "Then GoPay, Ovo, and Dana which quickly entered various regions with various product variations."
        },
        {
            p: "What needs to be emphasized here is that all of the companies mentioned above are new subsidiaries with less than five years of operation. They are more daring to work on the unbanked and unbankable segments than those who have been in the industry for a longer time."
        },
        {
            h4:'How banks do credit scoring'
        },
        {
            p: "The way banks analyze customers can be said to be quite conservative. The guidelines use 5C analysis with 5P principles. 5C includes character, capacity, capital, condition, and collateral. While the 5Ps are personality, purpose, prospect, payment, and party."
        },
        {
            p: "Every time you apply for credit to a bank, regardless of the type of product, the process requires a SLIK/Financial Information Service System (formerly called BI Checking or SID (Debtor Information System) as a determinant of the eligibility of prospective debtors."
        },
        {
            p: "SLIK can be accessed 24/7 online and offline by financial institutions, both banks and non-banks, as long as they are registered as members of the Credit Information Bureau (called the Credit Information Management Agency/LPIP). The SLIK contains information on debtors and credit facilities that are exchanged between financial institutions."
        },
        {
            p: "The customer has a credit score from his collectability record, calculated from 1 to 5. The smaller the score, the greater the potential for receiving applications. If he gets a score of 3, 4, and 5 he will automatically be rejected because he is blacklisted. People who have no credit history at all are included in the line that is automatically rejected."
        },
        {
            p: "Considering that banks only take bankable segments that have a credit history, the data sources used are mostly credit data plus other data to strengthen credit scoring."
        },
        {
            p: "It's different with fintech startups. Because customers do not necessarily have sufficient credit data, fintech startups will rely on other data or so-called alternative data to generate credit scores."
        },
        {
            image:require('@/assets/idImage/newdetail/newfive3.jpg')
        },
        {
            p: '"So the risk appetite in using credit scoring may be different, whether it is more risk tolerance or not, and this depends on each need," said Pefindo President Director, Yohanes Arts Abimanyu (7/11).'
        },
        {
            p: "The question that then arises is whether the credit analysis that has been used by banks is fully qualified? The answer varies, depending on the point of view used."
        },
        {
            p: "According to Fineoz Co-Founder and CEO Anis Radianis, an AI-based credit risk solution service, there are three primary quality criteria for credit scores. First, the level of accuracy of credit scores in choosing good and bad prospective customers. Second, a dynamic model following the latest developments, and a credit score that not only reduces risk but is able to maximize profit."
        },
        {
            p: "This primary quality is very important because it can determine the survival of financial institutions in running their business."
        },
        {
            p: "In Indonesia, unfortunately, credit scores still rely on internal sources which fundamentally have many weaknesses. For example, in sorting out customers who are able to pay debts, they still use the traditional statistical approach which is very inaccurate, not dynamic, and less profitable."
        },
        {
            p: "In general, the use of credit data in making credit scores will have better quality when compared to using alternative data."
        },
        {
            p: '"Why still use the traditional approach? Because it’s easy to explain, and simple. So there are some financial institutions who consider the quality of their credit scores to be good," explained Anis to DailySocial (20/11).'
        },
        {
            p: "The end result with this approach can really reduce the level of default risk. However, this has to be paid for by the many rejections of prospective customers because banks prefer to play it safe."
        },
        {
            p: "Not to mention secondary qualities such as speed levels. Many financial institutions take days for the underwriting process. Indeed, there are already players who make credit scores in minutes, but the primary quality in sorting good or bad is still the old approach."
        },
        {
            p: '"Banks can use a credit scoring model which is calibrated once or twice a year, because in a year there are many new things that can happen to maximize their profits by working with qualified prospective customers," he added.'
        },
        {
            p: "Banks cannot be as dynamic as fintech startups, but they do not rule out collaborating while still adhering to prudent principles. This can be seen in various collaborations in distributing productive loans to micro businesses and being registered as fintech borrowers."
        },
        {
            p: "This strategy shows that banks rely on the method and quality of credit scores in fintech startups. They want to increase the distribution of credit funds, by minimizing the risk of default because this distribution is recorded outside their accounting books."
        },
        {
            p: "In the end, the bank must continue to carry out its function as an intermediary, collecting funds from the surplus community and channeling it back to the deficit community (requiring financing from the bank)."
        },
        {
            p: "One of the banks that DailySocial contacted was BCA. EVP Secretariat & Corporate Communication BCA Hera F Haryn explained that the credit score used by BCA still uses data contained within BCA, such as debtor demographic data and transactions."
        },
        {
            p: '"As for the scoring technique, we use two methods, namely statistical logistic regression and start using machine learning," he said (14/11).'
        },
        {
            p: "Logistic regression is one of the popular statistical models used for binary classification, prediction of this or that type, yes or no, A or B, etc. It can also be used for multiclass classification."
        },
        {
            p: "BCA realized the LC Automize solution, together with AI startup from Singapore 6Estates, to automate manual documents and compliance checks based on international rules and international standards when analyzing LC (letter of credit) documents, by combining AI and robotic process automation for the trade finance business."
        },
        {
            p: "This method is expected to reduce the turnaround time for processing each incoming application. BCA can also grow its business exponentially without facing scalability issues."
        },
        {
            p: "This is still the early stages of implementing machine learning in the BCA business structure. Most likely LC Automize will be passed on to other lines."
        },
        {
            h4: "How fintech builds a credit score"
        },
        {
            p: "Basically, all companies, whether engaged in fintech or not, can collect customer data, whether online or offline, to be reused for various purposes. One of them is building a credit analysis system."
        },
        {
            p: "This understanding can be a provision that all companies have the capability to have an independent credit score system, as long as they have the technology and expertise."
        },
        {
            p: "The initial way Gojek or Traveloka released financial products, such as PayLater, also started from collecting data on consumer habits which were nurtured slowly until finally they could be utilized for further development in the financial sector."
        },
        {
            p: "Meanwhile, fintech lending startups mostly build their credit scores with other data that is not yet available in the credit bureaus. Before tripping over a case, initially players could access various data on the smartphone of the prospective debtor."
        },
        {
            p: "Now OJK limits digital data that can be accessed from smartphones, namely cameras, microphones, and locations. These three are considered the most relevant and needed by fintech lending companies to identify potential customers."
        },
        {
            image:require('@/assets/idImage/newdetail/newfive4.jpg')
        },
        {
            p: "For Tongdun, China's digital financial innovation platform for credit scores that have been registered with the OJK, these three types of data are actually still considered insufficient to obtain data on customer habits. For startups like them, the main point is to look holistically, from various sides, through as much data as possible to produce an accurate credit analysis."
        },
        {
            p: "Therefore, the company is discussing with PLN, BPJS, Dukcapil, Directorate General of Taxes, and telecommunications companies to utilize their data in depth for analysis needs. So far, banks have not fully utilized these basic data."
        },
        {
            p: "Director of Consulting and Solution Tongdun Suhardiman Agung explained, the digital footprint in Indonesia is not evenly spread, it is still concentrated in big cities. He gave an example, PLN electricity bills are classified as basic data that can provide an overview of a person's finances."
        },
        {
            p: "From there, it can also be seen how to verify addresses by looking at their PLN customer IDs, to make sure they are not fraudsters. Seeing what the economic background looks like is enough to pay attention to electricity consumption. For example, a customer sells with such a turnover, then the electricity consumption must match the prediction."
        },
        {
            image:require('@/assets/idImage/newdetail/newfive5.jpg')
        },
        {
            p: "Meanwhile, Tongdun still utilizes digital data to assist partners in risk analysis, but everything must go through customer licensing. Customers should also be aware that they are providing access to data, whether it's from a Facebook account or an e-commerce account to get credit."
        },
        {
            p: "Niche fintech startups, such as Fineoz and Tongdun, are competing to provide speed in risk analysis with AI technology, machine learning, computing platforms, and core technologies combined with API and cloud computing."
        },
        {
            p: "Anis explained that it is not always good to have a lot of data because according to him, quantity is very much different from quality. The greater the quantity of data does not guarantee the better the quality of analysis and credit decisions produced."
        },
        {
            p: '"Fineoz focuses on improving the quality of credit decisions. We do not deny the importance of multiple data sources. However, with AI technology, all data limitations can be overcome more easily."'
        },
        {
            p: "Fineoz itself has processed nearly 3.5 million customer data through several strategic partnerships. There are various types of credit data, including commercial credit data (invoice financing, seller financing, merchant financing, etc.) and consumer credit (motorcycle, car, KTA, and payday loans)."
        },
        {
            p: "Not to be outdone, Pefindo Credit Bureau (PBK) collects credit data from various sources. Starting from SID BI, SLIK OJK, financial institutions that are members of PBK, including cooperatives, fintech p2p lending, and non-financial institutions such as retailers."
        },
        {
            p: "They also cooperate with other institutions to access non-credit data, such as BPJS Employment, Taspen, tax identity, bankruptcy data, defaults from Supreme Court decisions, issuer data from the IDX, and company rating data from the Indonesian Securities Rating Agency."
        },
        {
            p: "Yohanes said that PBK has recorded credit data of 91 million individual data and 500 thousand company data. So that all this data can be used as well as possible, the company continues to develop the accuracy of the data and methodology of PBK credit scoring."
        },
        {
            p: '"In addition, we plan to develop alternative credit scoring to cater for people who are still unbanked or underserved. In addition, it is possible to develop AI."'
        },
        {
            h4:'The future of credit scores in Indonesia'
        },
        {
            p: "Financial institutions and fintech cannot always run alone. The prudence of banks when disbursing loans and the dynamics of fintech in processing data for risk analysis are the right mix to work with unbanked and unbankable customers."
        },
        {
            p: "It's no wonder that more and more financial institutions, including p2plending services, are collaborating with companies like Tongdun and Fineoz to help them analyze potential customers from various angles."
        },
        {
            image:require('@/assets/idImage/newdetail/newfive6.jpg')
        },
        {
            p: "Most recently, Bank Permata became the largest institutional lender in Kredivo. The bank disburses up to Rp1 trillion to be redistributed by the company."
        },
        {
            p: "The bank's decision to put such large funds is definitely not an easy decision. Startups like Kredivo must have a standardized risk management system on par with banks."
        },
        {
            p: "On Monday (2/12), Pefindo Credit Bureau collaborated with Fineoz to develop credit information in the form of alternative scoring through the use of alternative data."
        },
        {
            p: '"We collaborate on the use of alternative data, so that the coverage of the unbanked community for credit scoring and financial access can be greater," said Anis.'
        },
        {
            p: "The Indonesian Joint Funding Fintech Association (AFPI) also released the Fintech Data Center (FDC) data center to make it easier for p2p players to make credit assessments. Its function is the same as BI Checking and SLIK with the spirit of avoiding potential defaults, fraud, and excessive credit distribution."
        },
        {
            p: "FDC has been connected with BI Checking and SLIK. Later this partnership will increase with other parties, including BPJS Health and Employment, insurance, multi-finance, banking, and the capital market."
        },
        {
            p: "Suhardiman said, the ability of fintech players who focus on credit analysis certainly has more value. Investment in technology and expertise that must be poured is not a cheap price."
        },
        {
            p: '"We are more like a data aggregator, connected to various data sources. Moreover, we have special expertise in this field. Fintech players or banks do not necessarily have exposure like us," he said.'
        },
        {
            p: "Currently, the first layer that is most helped by the presence of credit score players is banking. The next layer will be cross-industry. "
        },
        {
            p: "Suhardiman gave an example, in China, the utilization of credit analysis is very advanced. There, data like this is used by logistics companies to analyze delivery status and driver profiling."
        },
        {
            p: "Insurance companies in China also use credit scores for claim payments as a measure to prevent potential fraud."
        },
        {
            p: '"The technology that we brought to Indonesia from China is still a small part. We can‘t necessarily bring everything because it adapts to the habits of the people here and requires personalization."'
        },
        {
            image:require('@/assets/idImage/newdetail/newfive7.jpg')
        },
        {
            p: "This can be a big picture that the demand for credit analysis needs will be higher in Indonesia."
        },
        {
            p: "One of the new players who are ready to step on the gas is CekAja. Initially CekAja was a financial product aggregator platform, then they soon entered a credit score business called CekSkor."
        },
        {
            p: "The product, which will be released early next year, is the realization of the acquisition by CekAja for id/x to assist in the scoring process with Experian, which has experience in the same field. Experian is one of the three largest credit scoring companies in the world, along with Equifax and Transunion."
        },
    ]
}